import React from 'react';
import { Container } from '@mui/material';
import WarehouseTransferRequestForm from '../components/warehouseTransfers/WarehouseTransferRequestForm';
import DashboardLayout from '../components/dashboard/DashboardLayout';

const EditWarehouseTransferRequest: React.FC = () => {
  return (
    <DashboardLayout>
      <Container maxWidth={false}>
        <WarehouseTransferRequestForm />
      </Container>
    </DashboardLayout>
  );
};

export default EditWarehouseTransferRequest;